import gql from 'graphql-tag';

const GET_ALL_TICKET_STATUS = gql`
  query {
    getAllStatus {
      id
      name
      description
    }
  }
`;

const GET_CUSTOMFIELD = gql`
  query($id: ID!, $module: String!) {
    getCustomField(fieldId: $id, module: $module) {
      id
      label
      columnName
      description
      fieldType
      options
      showToClient
      module
    }
  }
`;

const GET_TICKET_SLAMETA = gql`
  query {
    getTicketSLAMetaInfo
  }
`;

const GET_TICKET_URGENCY_FIELDS = gql`
  query {
    getAllUrgency {
      id
      name
    }
  }
`;

const GET_TICKET_IMPACT_FIELDS = gql`
  query {
    getAllImpact {
      id
      name
    }
  }
`;

const GET_PRIORITYMATRIX = gql`
  query {
    getPriorityMatrix {
      id
      impact
      urgency
      priority
    }
  }
`;

const GET_PRIORITY_MATRIX_ACTIVE_STATUS = gql`
  query {
    isPriorityMatrixEnabled
  }
`;

const GET_TICKET_PRIORITY_FIELDS = gql`
  query {
    getAllPriority {
      id
      name
      colorCode
    }
  }
`;

const GET_ALL_CUSTOM_FIELDS = gql`
  query($module: String!) {
    getAllCustomFields(module: $module) {
      id
      columnName
      label
      description
      fieldType
      options
      showToClient
    }
  }
`;

const GET_TICKET_CAUSE_FIELDS = gql`
  query {
    getAllCause {
      id
      name
    }
  }
`;

const GET_ALL_CATEGORIES = gql`
  query {
    getAllCategory {
      id
      name
      subCategories {
        id
        name
      }
    }
  }
`;

const GET_ALL_RESOLUTIONCODE = gql`
  query {
    getAllResolutionCode {
      id
      name
      description
    }
  }
`;

const ADD_CATEGORY = gql`
  mutation($name: String) {
    addCategory(input: { name: $name }) {
      id
      name
    }
  }
`;

const ADD_CATEGORIES = gql`
  mutation($categoryInput: [CategoryInput!]!) {
    addCategories(input: $categoryInput) {
      id
      name
      subCategories {
        id
        name
      }
    }
  }
`;

const UPDATE_CATEGORIES = gql`
  mutation($categoryInput: [CategoryInput!]!) {
    updateCategories(input: $categoryInput) {
      id
      name
      subCategories {
        id
        name
      }
    }
  }
`;

const DELETE_CATEGORIES = gql`
  mutation($ids: [ID!]!) {
    deleteCategories(ids: $ids)
  }
`;

const UPDATE_CATEGORY = gql`
  mutation($id: ID!, $name: String) {
    updateCategory(id: $id, input: { name: $name }) {
      id
      name
    }
  }
`;

const ADD_TICKET_STATUS = gql`
  mutation($name: String, $description: String) {
    addStatus(input: { name: $name, description: $description }) {
      id
      name
      description
    }
  }
`;

const ADD_TICKET_STATUSES = gql`
  mutation($status: [StatusInput!]!) {
    addStatuses(input: $status) {
      id
      name
      description
    }
  }
`;

const CREATE_CUSTOMFIELD = gql`
  mutation(
    $label: String!
    $description: String
    $fieldType: String!
    $showToClient: Boolean!
    $options: [String]!
    $module: String
  ) {
    createCustomField(
      input: {
        label: $label
        description: $description
        fieldType: $fieldType
        showToClient: $showToClient
        options: $options
        module: $module
      }
    ) {
      id
      label
      description
      fieldType
      showToClient
      options
      module
      columnName
    }
  }
`;

const UPDATE_CUSTOMFIELD = gql`
  mutation(
    $id: ID!
    $label: String!
    $description: String
    $showToClient: Boolean!
    $options: [String]
    $module: String
    $renamedOptions: JSON
  ) {
    updateCustomField(
      fieldId: $id
      input: {
        label: $label
        description: $description
        showToClient: $showToClient
        options: $options
        module: $module
        renamedOptions: $renamedOptions
      }
    ) {
      id
      label
      description
      fieldType
      showToClient
      options
      module
      columnName
    }
  }
`;

const UPDATE_TICKET_STATUS = gql`
  mutation($name: String, $description: String, $id: ID!) {
    updateStatus(id: $id, input: { name: $name, description: $description }) {
      name
      description
    }
  }
`;

const UPDATE_TICKET_STATUSES = gql`
  mutation($status: [StatusInput!]!) {
    updateStatuses(input: $status) {
      id
      name
      description
    }
  }
`;

const DELETE_TICKET_STATUS = gql`
  mutation($id: ID!) {
    deleteStatus(id: $id) {
      deleteStatus
    }
  }
`;

const DELETE_TICKET_STATUSES = gql`
  mutation($status: [ID!]!) {
    deleteStatuses(ids: $status)
  }
`;

const UPDATE_PRIORITY = gql`
  mutation($name: String, $id: ID!, $colorCode: String) {
    updatePriority(id: $id, input: { name: $name, colorCode: $colorCode }) {
      id
      name
      colorCode
    }
  }
`;

const UPDATE_PRIORITIES = gql`
  mutation($updatedPriority: [PriorityInput!]!) {
    updatePriorities(input: $updatedPriority) {
      id
      name
      colorCode
    }
  }
`;

const UPDATE_PRIORITY_MATRIX = gql`
  mutation($matrix: [PriorityMatrixInput!]!) {
    updatePriorityMatrix(input: $matrix) {
      id
      impact
      urgency
      priority
    }
  }
`;

const UPDATE_PRIORITY_MATRIX_ACTIVE_STATUS = gql`
  mutation($active: Boolean) {
    updatePriorityMatrixActiveStatus(active: $active)
  }
`;

const MANDATE_RESOLUTIONCODE = gql`
  mutation($mandate: Boolean) {
    mandateResolutionCode(mandate: $mandate) {
      mandateResolutionCode
    }
  }
`;

const DELETE_CUSTOM_FIELD = gql`
  mutation($id: ID!) {
    deleteCustomField(fieldId: $id)
  }
`;

const DELETE_CUSTOM_FORM = gql`
  mutation($id: ID!) {
    deleteTicketForm(formId: $id)
  }
`;

const UPDATE_STATUS_CONFIGURATION = gql`
  mutation($input: StatusConfigurationInput) {
    updateStatusConfiguration(input: $input)
  }
`;

const UPDATE_STATUS_CONFIGURATIONS = gql`
  mutation($input: [StatusConfigurationInput]) {
    updateStatusConfigurations(input: $input)
  }
`;

const GET_ALL_FIELDS = gql`
  query getAllFields($input: String!) {
    getAllFields(input: $input) {
      id
      module
      columnName
      label
      description
      fieldType
      fieldOptions
      fieldCategory
      showToClient
      mandatoryOnCreate
      mandatoryOnClosure
    }
  }
`;

const GET_ALL_FIELDS_V2 = gql`
  query getAllFields($input: String!) {
    getAllFields(input: $input) {
      id
      module
      entity {
        entityId
        name
      }
      columnName
      label
      description
      fieldType
      status
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      fieldCategory
      mandatoryOnCreate
      mandatoryOnClosure
      editable
      parentField {
        id
        module
        columnName
        fieldCategory
        label
        description
      }
    }
  }
`;

const GET_FIELD = gql`
  query getField($input: FieldIdentifierInput!) {
    getField(input: $input) {
      id
      label
      columnName
      description
      fieldType
      fieldCategory
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      module
      mandatoryOnCreate
      mandatoryOnClosure
      parentField {
        id
        module
        columnName
        fieldCategory
        label
        description
      }
    }
  }
`;

const CREATE_FIELD = gql`
  mutation($input: FieldInput!) {
    createField(input: $input) {
      id
      fieldCategory
      columnName
      label
      description
      fieldType
      showToClient
      fieldOptions
      module
      mandatoryOnCreate
      mandatoryOnClosure
    }
  }
`;

const CREATE_FIELD_V2 = gql`
  mutation($input: CreateFieldInput!) {
    createFieldV2(input: $input) {
      id
      module
      columnName
      label
      description
      fieldType
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
        }
        deletable
      }
      showToClient
      fieldCategory
      mandatoryOnCreate
      mandatoryOnClosure
      editable
      parentField {
        module
        id
        columnName
        fieldCategory
        label
      }
    }
  }
`;

const UPDATE_FIELD = gql`
  mutation($input: FieldInput!) {
    updateField(input: $input) {
      id
      label
      description
      fieldType
      showToClient
      fieldOptions
      module
      columnName
      mandatoryOnCreate
      mandatoryOnClosure
    }
  }
`;

const UPDATE_FIELD_V2 = gql`
  mutation($input: UpdateFieldInput!) {
    updateFieldV2(input: $input) {
      id
      module
      columnName
      label
      description
      fieldType
      status
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      fieldCategory
      mandatoryOnCreate
      mandatoryOnClosure
      editable
      parentField {
        id
        module
        fieldCategory
        columnName
        label
        description
      }
    }
  }
`;

const DELETE_FIELD = gql`
  mutation($input: FieldIdentifierInput!) {
    deleteField(input: $input) {
      id
      columnName
    }
  }
`;

const DELETE_FIELD_V2 = gql`
  mutation($input: FieldIdentifierInput!) {
    deleteFieldV2(input: $input) {
      id
      columnName
    }
  }
`;

const DELETE_FIELD_V3 = gql`
  mutation($input: FieldIdentifierInput!) {
    deleteFieldV3(input: $input)
  }
`;

const GET_FIELDS = gql`
  query getFields($input: [FieldIdentifierInput!]!) {
    getFields(input: $input) {
      id
      label
      columnName
      description
      fieldType
      status
      parentField {
        id
        columnName
        module
        fieldCategory
        label
      }
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      module
      mandatoryOnCreate
      mandatoryOnClosure
      fieldCategory
    }
  }
`;

const GET_FIELD_CONSTRAINTS = gql`
  query getFieldConstraints($input: String!) {
    getFieldConstraints(input: $input) {
      totalLimit
      paragraphTotalLimit
      textCharLength
      optionCharLength
      decimalPrecision
      decimalScale
      numericPrecision
      multiChoiceOptionsLimit
      singleChoiceOptionsLimit
    }
  }
`;

const GET_FIELD_LIMIT = gql`
  query getFieldLimit($input: [String!]!) {
    getFieldLimit(input: $input) {
      entity {
        entityId
        name
      }
      allowedCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      consumedCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      inactiveCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      allowedCommonCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      consumedCommonCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      inactiveCommonCount {
        total
        varchar
        text
        smallint
        number
        temporal
      }
      valueLimit {
        textCharLength
        optionCharLength
        decimalPrecision
        decimalScale
        numericPrecision
        multiChoiceOptionsLimit
        singleChoiceOptionsLimit
      }
    }
  }
`;

const GET_FIELD_TYPE_VS_GROUP_MAPPING = gql`
  query getFieldTypeVSGroupMapping($isITDoc: Boolean) {
    getFieldTypeVSGroupMapping(isITDoc: $isITDoc)
  }
`;

const GET_OPTIONS = gql`
  query getOptions($input: GetOptionsInput!) {
    getOptions(input: $input) {
      id
      value
      order
      description
      details
      parentOption {
        id
      }
      deletable
    }
  }
`;

const GET_ELIGIBLE_PARENTS = gql`
  query getEligibleParentFields($input: String!) {
    getEligibleParentFields(input: $input) {
      id
      module
      columnName
      label
      description
      fieldCategory
      editable
      parentField {
        id
        module
        columnName
        fieldCategory
        label
        description
      }
    }
  }
`;

const GET_PRIORITY_MATRIX_CONFIG = gql`
  query {
    getPriorityMatrixConfig {
      priorityMatrixMapping {
        id
        impact {
          id
          value
        }
        urgency {
          id
          value
        }
        priority {
          id
          value
        }
      }
      active
    }
  }
`;

const UPDATE_PRIORITY_MATRIX_CONFIG = gql`
  mutation($input: UpdatePriorityMatrixConfigInput!) {
    updatePriorityMatrixConfig(input: $input) {
      priorityMatrixMapping {
        id
        impact {
          id
          value
        }
        urgency {
          id
          value
        }
        priority {
          id
          value
        }
      }
      active
    }
  }
`;

export {
  MANDATE_RESOLUTIONCODE,
  UPDATE_CATEGORY,
  GET_PRIORITYMATRIX,
  GET_PRIORITY_MATRIX_ACTIVE_STATUS,
  UPDATE_PRIORITY,
  DELETE_TICKET_STATUS,
  UPDATE_TICKET_STATUS,
  GET_ALL_RESOLUTIONCODE,
  GET_TICKET_PRIORITY_FIELDS,
  GET_ALL_TICKET_STATUS,
  ADD_TICKET_STATUS,
  GET_ALL_CATEGORIES,
  GET_TICKET_URGENCY_FIELDS,
  GET_TICKET_CAUSE_FIELDS,
  GET_TICKET_IMPACT_FIELDS,
  ADD_CATEGORY,
  GET_TICKET_SLAMETA,
  GET_ALL_CUSTOM_FIELDS,
  CREATE_CUSTOMFIELD,
  UPDATE_CUSTOMFIELD,
  DELETE_CUSTOM_FORM,
  GET_CUSTOMFIELD,
  ADD_CATEGORIES,
  UPDATE_CATEGORIES,
  DELETE_CATEGORIES,
  UPDATE_PRIORITY_MATRIX,
  UPDATE_PRIORITY_MATRIX_ACTIVE_STATUS,
  UPDATE_PRIORITIES,
  ADD_TICKET_STATUSES,
  DELETE_TICKET_STATUSES,
  UPDATE_TICKET_STATUSES,
  DELETE_CUSTOM_FIELD,
  UPDATE_STATUS_CONFIGURATION,
  UPDATE_STATUS_CONFIGURATIONS,
  GET_ALL_FIELDS,
  GET_ALL_FIELDS_V2,
  GET_FIELD,
  UPDATE_FIELD,
  UPDATE_FIELD_V2,
  DELETE_FIELD,
  DELETE_FIELD_V2,
  DELETE_FIELD_V3,
  GET_FIELDS,
  CREATE_FIELD,
  CREATE_FIELD_V2,
  GET_FIELD_CONSTRAINTS,
  GET_OPTIONS,
  GET_ELIGIBLE_PARENTS,
  GET_PRIORITY_MATRIX_CONFIG,
  UPDATE_PRIORITY_MATRIX_CONFIG,
  GET_FIELD_LIMIT,
  GET_FIELD_TYPE_VS_GROUP_MAPPING
};
